import { Drawer, Position } from "@next-platform/client-common-spicy-ui";
import React from "react";

import { HEADER_HEIGHT } from "@/constants";
import { cn } from "@/utils";

const DEFAULT_DESKTOP_FILTER_WIDTH = 240;
const MOBILE_FILTER_WIDTH = 260;
const FILTER_TOP_OFFSET = 10;
const FILTER_BOTTOM_OFFSET = 30;

export type FilterWrapperProps = {
  children: React.ReactNode;
  isDesktop: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  desktopWidth?: number;
};

export const FilterWrapper = ({ children, isDesktop, open, onOpenChange, desktopWidth = DEFAULT_DESKTOP_FILTER_WIDTH }: FilterWrapperProps) => {
  const componentWidth = isDesktop ? desktopWidth : MOBILE_FILTER_WIDTH;
  return (
    <div
      className={cn("flex h-full shrink-0", isDesktop && "sticky z-10 mr-[18px]")}
      style={{
        top: HEADER_HEIGHT + FILTER_TOP_OFFSET,
        maxHeight: `calc(100vh - ${HEADER_HEIGHT + FILTER_BOTTOM_OFFSET}px)`,
      }}
    >
      {isDesktop ? (
        <div style={{ width: componentWidth }}>{children}</div>
      ) : (
        <Drawer open={open} onOpenChange={onOpenChange} position={Position.RIGHT} className="p-2.5 bg-gray-3" style={{ width: componentWidth }}>
          {children}
        </Drawer>
      )}
    </div>
  );
};
